import { render, staticRenderFns } from "./IconFields.vue?vue&type=template&id=35b3ffe9"
import script from "./IconFields.vue?vue&type=script&lang=js"
export * from "./IconFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports